export const HeaderMenuListTop = [
  {
    label: "Nous connaître",
    children: [
      {
        label: "à la une",
        children: [
          {
            label: "Actualités",
          },
          {
            label: "Agenda",
          },
          {
            label: "Presse",
          },
          {
            label: "Newsletter",
          },
        ],
      },
      {
        label: "L'Institut",
      },
      {
        label: "Gouvernance",
      },
      {
        label: "Plan Stratégique 2030",
      },
      {
        label: "Départements",
      },
      {
        label: "Hôpital de Chevilly-Larue",
      },
      {
        label: "Cancer Campus",
      },
      {
        label: "Rapports d'activité",
      },
      {
        label: "Partenariats",
        children: [
          {
            label: "Partenariats nationaux",
          },
          {
            label: "Partenariats internationaux",
          },
          {
            label: "Cancer Core Europe",
          },
        ],
      },
      {
        label: "Cancer au travail",
      },
      {
        label: "Recrutement",
        children: [
          {
            label: "Offres d’emploi",
          },
          {
            label: "Politique RH",
          },
          {
            label: "Index égalité professionnelle",
          },
        ],
      },
    ],
  },
  {
    label: "Infos patients",
    children: [
      {
        label: "Guide d’accueil",
      },
      {
        label: "Portail patient",
      },
      {
        label: "Mieux vivre le cancer",
        children: [
          {
            label: "Activités sportives",
          },
          {
            label: "Pratiques psycho-corporelles",
          },
          {
            label: "Art à l'hôpital",
          },
          {
            label: "Accompagnement socio-esthétique",
          },
          {
            label: "Programme MOLITOR Evasion",
          },
        ],
      },
      {
        label: "Espace de Rencontres et Information",
      },
      {
        label: "Droits du patient",
        children: [
          {
            label: "Données personnelles",
          },
          {
            label: "Etudes et essais cliniques",
          },
          {
            label: "Personne de confiance",
          },
          {
            label: "Directives anticipées",
          },
          {
            label: "Charte de laïcité",
          },
          {
            label: "Mineurs et majeurs protégés",
          },
          {
            label: "Refus de soins",
          },
          {
            label: "Don d'organes",
          },
        ],
      },
      {
        label: "Démocratie sanitaire",
        children: [
          {
            label: "Comité de patients",
          },
          {
            label: "Conseil des enfants",
          },
          {
            label: "Comité d'éthique",
          },
          {
            label: "Commission des relations avec les usagers",
          },
        ],
      },
      {
        label: "Démarches administratives",
        children: [
          {
            label: "Prescription transport",
          },
          {
            label: "Accès au dossier médical",
          },
          {
            label: "Médiateur médical",
          },
          {
            label: "Assistance sociale",
          },
          {
            label: "Aides à domicile",
          },
        ],
      },
      {
        label: "Paiement en ligne",
      },
    ],
  },
  {
    label: "Infos pratiques",
    children: [
      {
        label: "Accès GR1 – Villejuif",
      },
      {
        label: "Accès GR2 – Chevilly Larue",
      },
      {
        label: "Plan de l'institut",
      },
      {
        label: "Services sur place",
        children: [
          {
            label: "Pratique",
          },
          {
            label: "Restauration",
          },
          {
            label: "Handicap",
          },
          {
            label: "Culte",
          },
          {
            label: "Hôpital de Chevilly-Larue",
          },
        ],
      },
      {
        label: "Hébergement",
      },
      {
        label: "Associations",
      },
      {
        label: "Contacts",
      },
    ],
  },
];

export const HeaderMenuListBottom = [
  {
    label: "Les Soins",
    class: "les-soins",
    children: [
      {
        label: "Types de cancer",
        children: [
          {
            label: "Tumeur du cerveau",
          },
          {
            label: "Cancer colorectal",
          },
          {
            label: "Cancers digestifs",
          },
          {
            label: "Cancer gynécologique",
          },
          {
            label: "Hématologie",
          },
          {
            label: "Tumeur neuro-endocrine",
          },
          {
            label: "Cancer ORL / Tête et Cou",
          },
          {
            label: "Cancer de la peau",
          },
          {
            label: "Cancer du poumon",
          },
          {
            label: "Cancer de la prostate",
          },
          {
            label: "Cancer du rein",
          },
          {
            label: "Sarcome",
          },
          {
            label: "Tumeur de la surrénale",
          },
          {
            label: "Cancer du sein",
          },
          {
            label: "Cancer du testicule",
          },
          {
            label: "Cancer de la thyroïde",
          },
          {
            label: "Cancer de la vessie",
          },
          {
            label: "Cancers HPV induits",
          },
        ],
      },
      {
        label: "Enfant et adolescent",
        children: [
          {
            label: "User",
          },
          {
            label: "User",
          },
          {
            label: "User",
          },
        ],
      },
      {
        label: "Onco-gériatrie",
      },
      {
        label: "Traitements",
      },
      {
        label: "Essais cliniques",
      },
      {
        label: "Soins de support",
      },
      {
        label: "Hospitalisation",
      },
      {
        label: "Soins à domicile",
      },
      {
        label: "Qualité et Sécurité des soins",
      },
      {
        label: "Patients Internationaux",
      },
      {
        label: "Interception",
      },
      {
        label: "Outre-mer",
      },
    ],
  },
  {
    label: "La Recherche",
    class: "la-recherche",
    children: [
      {
        label: "Gouvernance de la recherche",
        children: [
          {
            label: "Management",
          },
          {
            label: "Management",
          },
          {
            label: "Management",
          },
        ],
      },
      {
        label: "Programmes médico-scientifiques",
      },
      {
        label: "Équipes de Recherche",
      },
      {
        label: "Unités de recherche",
      },
      {
        label: "Plateformes",
      },
      {
        label: "Recherche clinique",
      },
      {
        label: "Épidémiologie et prévention",
      },
      {
        label: "Valorisation de la recherche",
      },
    ],
  },
  {
    label: "L'Enseignement",
    class: "les-enseignement",
    children: [
      {
        label: "Admin 1",
      },
      {
        label: "Admin 2",
      },
      {
        label: "Admin 3",
      },
      {
        label: "Admin 4",
      },
    ],
  },
  {
    label: "Nous soutenir",
    class: "nous-soutenir",
    children: [
      {
        label: "Management 1",
        children: [
          {
            label: "Management 2",
          },
          {
            label: "Management 3",
          },
          {
            label: "Management 4",
          },
        ],
      },
    ],
  },
];
